module.exports = __webpack_public_path__ + "img/ring_y_skip_null_0@3x.c1441b25.png";